"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _materialSymbols = require("@design/icons/material-symbols");
var _button = require("@design/ui/button");
var _spinner = require("@design/ui/spinner");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ActionButton(_ref) {
  var primary = _ref.primary,
    onClick = _ref.onClick,
    disabled = _ref.disabled,
    isLoading = _ref.isLoading,
    children = _ref.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_button.Button, {
    type: "button",
    variant: primary ? "default" : "outline",
    size: "lg",
    onClick: onClick,
    disabled: isLoading || disabled,
    "aria-busy": isLoading || undefined,
    className: "flex-1 min-w-0",
    "data-sentry-element": "Button",
    "data-sentry-component": "ActionButton",
    "data-sentry-source-file": "IssueActionBar.tsx",
    children: [isLoading && /*#__PURE__*/(0, _jsxRuntime.jsx)(_spinner.Spinner, {
      "data-icon": "inline-start",
      "aria-hidden": "true"
    }), children]
  });
}
function IssueActionBar(_ref2) {
  var onPrev = _ref2.onPrev,
    onNext = _ref2.onNext,
    hasPrev = _ref2.hasPrev,
    hasNext = _ref2.hasNext,
    onApplyAll = _ref2.onApplyAll,
    onConcede = _ref2.onConcede,
    isResponded = _ref2.isResponded,
    isConceded = _ref2.isConceded,
    _ref2$isApplyDisabled = _ref2.isApplyDisabled,
    isApplyDisabled = _ref2$isApplyDisabled === void 0 ? false : _ref2$isApplyDisabled,
    isConcedePending = _ref2.isConcedePending,
    _ref2$applyLabel = _ref2.applyLabel,
    applyLabel = _ref2$applyLabel === void 0 ? "Apply All" : _ref2$applyLabel,
    _ref2$unmarkLabel = _ref2.unmarkLabel,
    unmarkLabel = _ref2$unmarkLabel === void 0 ? "Unmark" : _ref2$unmarkLabel,
    _ref2$concedeLabel = _ref2.concedeLabel,
    concedeLabel = _ref2$concedeLabel === void 0 ? "Concede" : _ref2$concedeLabel,
    _ref2$unconcedeLabel = _ref2.unconcedeLabel,
    unconcedeLabel = _ref2$unconcedeLabel === void 0 ? "Unconcede" : _ref2$unconcedeLabel;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex flex-row items-center justify-between w-full min-h-10 bg-background-subtle flex-none p-(--component-base-focus-ring-width)",
    "data-sentry-component": "IssueActionBar",
    "data-sentry-source-file": "IssueActionBar.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
      type: "button",
      variant: "ghost",
      size: "icon-xs",
      "aria-label": "Previous issue",
      onClick: onPrev,
      disabled: !hasPrev,
      "data-sentry-element": "Button",
      "data-sentry-source-file": "IssueActionBar.tsx",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ChevronLeftIcon, {
        "data-sentry-element": "ChevronLeftIcon",
        "data-sentry-source-file": "IssueActionBar.tsx"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "flex gap-0 flex-1",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(ActionButton, {
        primary: true,
        onClick: onApplyAll,
        disabled: isApplyDisabled,
        "data-sentry-element": "ActionButton",
        "data-sentry-source-file": "IssueActionBar.tsx",
        children: isResponded ? unmarkLabel : applyLabel
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(ActionButton, {
        onClick: onConcede,
        isLoading: isConcedePending,
        "data-sentry-element": "ActionButton",
        "data-sentry-source-file": "IssueActionBar.tsx",
        children: isConceded ? unconcedeLabel : concedeLabel
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
      type: "button",
      variant: "ghost",
      size: "icon-xs",
      "aria-label": "Next issue",
      onClick: onNext,
      disabled: !hasNext,
      "data-sentry-element": "Button",
      "data-sentry-source-file": "IssueActionBar.tsx",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ChevronRightIcon, {
        "data-sentry-element": "ChevronRightIcon",
        "data-sentry-source-file": "IssueActionBar.tsx"
      })
    })]
  });
}
var _default = exports.default = IssueActionBar;